import React, { Fragment } from 'react';
import {
  Col,
  Row,
  Alert,
  FormGroup,
  UncontrolledTooltip,
  Input,
  Label,
} from 'reactstrap';
import { get } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { countryList, usStateList } from './CountryDropdown';

const ReadOnlyTemplate = ({
  emailData,
  messageData,
  taxData,
  feeData,
  chargeByInvoice,
  chargeByLot,
}) => (
  <>
    <Row className="mt-5">
      <Col xs={12}>
        <Alert color="primary">
          Email Settings
        </Alert>
      </Col>
    </Row>
    <Row>
      <Col xs={12} sm={5} className="mt-3">
        <h3>Email Subject&nbsp;</h3>
        <FormGroup>
          {emailData.emailSubject}
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col xs={12} sm={5}>
        <FormGroup>
          <h3>Reply To Name&nbsp;</h3>
          {emailData.replyName}
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col xs={12} sm={5}>
        <h3>Reply To Email&nbsp;</h3>
        <FormGroup>
          {emailData.replyEmail}
        </FormGroup>
      </Col>
    </Row>
    {emailData.BCC
      && (
      <Row>
        <Col xs={12} sm={5}>
          <FormGroup>
            <h3>BBC&nbsp;</h3>
          </FormGroup>
          {emailData.BCC}
        </Col>
      </Row>
      )}
    <Row>
      <Col xs={12} sm={7}>
        <h3> House Address</h3>
        {emailData.selectedAddr && (
          <Fragment>
            {`${emailData.selectedAddr.addressStreet1}${emailData.selectedAddr.addressStreet2}, ${emailData.selectedAddr.addressCity},${emailData.selectedAddr.showStates ? ` ${emailData.selectedAddr.stateName},` : ''} ${emailData.selectedAddr.countryName}`}
          </Fragment>
        )}
      </Col>
    </Row>
    <Row className="mt-5">
      <Col xs={12} className="mb-3">
        <Alert color="primary">
          Additional Charges | Taxes and Fees&nbsp;
          <FontAwesomeIcon icon="question-circle" id="taxFees" />
          <UncontrolledTooltip placement="bottom" target="taxFees">
            Once invoices have been created for a sale, you cannot edit or add tax types in the invoice template for that sale.
            Please be sure to enter tax types in your invoice template prior to creating invoices for each auction.
          </UncontrolledTooltip>
        </Alert>
      </Col>
      <Col xs={4}>
        <h3>Apply charges per:</h3>
      </Col>
      <Col xs={2}>
        <FormGroup check>
          <Input
            type="radio"
            id="byInvoice"
            name="applyCharges"
            defaultChecked={chargeByInvoice}
            disabled
          />
          <Label check>
            Invoice
          </Label>
        </FormGroup>
      </Col>
      <Col xs={2}>
        <FormGroup check>
          <Input
            type="radio"
            id="byLot"
            name="applyCharges"
            defaultChecked={chargeByLot}
            disabled
          />
          <Label check>
            Lot
          </Label>
        </FormGroup>
      </Col>
      <Col xs={12} className="mb-3">
        Depending on your local, state, federal, and country tax laws, you may need to include additional taxes to your invoices. United States Sales Tax will be automatically calculated and applied at the lot level.
      </Col>
    </Row>
    {taxData
            && (
              <div>
                {taxData && taxData.map((item, index) => {
                  const countryIdentifier = item.taxCountryID ? item.taxCountryID : item.taxCountry;
                  const currentCountryObj = countryList.filter((country) => country.value === countryIdentifier);
                  const currentCountryLabel = get(currentCountryObj[0], 'label', '');

                  let showState = false;
                  let stateName;

                  if (countryIdentifier === 'US') {
                    showState = true;
                    const stateObj = usStateList.filter((state) => state.value === item.taxStateID);
                    stateName = get(stateObj[0], 'label', '');
                  }

                  return (
                    <>
                      <div key={index} className="mt-4">
                        <Row>
                          <Col xs={4}>
                            <h3>Charge Type: Tax</h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={3}>
                            <FormGroup>
                              <h3>Name</h3>
                              {item.taxType}
                            </FormGroup>
                          </Col>
                          <Col xs={2}>
                            <FormGroup>
                              <h3>Rate %</h3>
                              {item.formattedTaxRate}
                            </FormGroup>
                          </Col>
                          <Col xs={3}>
                            <FormGroup>
                              <h3>Country / Region</h3>
                              {currentCountryLabel}
                            </FormGroup>
                          </Col>
                          {showState
                              && (
                              <Col xs={3}>
                                <h3>State</h3>
                                {stateName}
                              </Col>
                              )}
                        </Row>
                        <Row>
                          <Col xs={3}>
                            <h3>Apply tax type to:</h3>
                          </Col>
                          <Col xs={2}>
                            <FormGroup check>
                              <Input
                                type="checkbox"
                                id="taxHammer"
                                name="taxHammer"
                                disabled
                                checked={item.taxHammer}
                              />
                              <Label check>
                                Hammer
                              </Label>
                            </FormGroup>
                          </Col>
                          <Col xs={2}>
                            <FormGroup check>
                              <Input
                                type="checkbox"
                                id="taxLiveFee"
                                name="taxLiveFee"
                                disabled
                                checked={item.taxLiveFee}
                              />
                              <Label check>
                                Live Fee
                              </Label>
                            </FormGroup>
                          </Col>
                          <Col xs={2}>
                            <FormGroup check>
                              <Input
                                type="checkbox"
                                id="taxPremium"
                                name="taxPremium"
                                disabled
                                checked={item.taxPremium}
                              />
                              <Label check>
                                BP
                              </Label>
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                    </>
                  );
                })}
              </div>
            )}
    {feeData
            && (
              <div>
                {feeData && feeData.map((item, index) => {
                  const countryIdentifier = item.feeCountryID ? item.feeCountryID : item.feeCountry;
                  const currentCountryObj = countryList.filter((country) => country.value === countryIdentifier);
                  const currentCountryLabel = get(currentCountryObj[0], 'label', '');

                  let showState = false;
                  let stateName;

                  if (countryIdentifier === 'US') {
                    showState = true;
                    const stateObj = usStateList.filter((state) => state.value === item.feeStateID);
                    stateName = get(stateObj[0], 'label', '');
                  }
                  return (
                    <>
                      <div key={index} className="mt-4">
                        <Row>
                          <Col xs={4}>
                            <h3>Charge Type: Fee</h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={3}>
                            <FormGroup>
                              <h3>Name</h3>
                              {item.feeType}
                            </FormGroup>
                          </Col>
                          <Col xs={2}>
                            <FormGroup>
                              <h3>Rate %</h3>
                              {item.formattedFeeRate}
                            </FormGroup>
                          </Col>
                          <Col xs={3}>
                            <FormGroup>
                              <h3>Country / Region</h3>
                              {currentCountryLabel}
                            </FormGroup>
                          </Col>
                          {showState
                              && (
                              <Col xs={3}>
                                <h3>State</h3>
                                {stateName}
                              </Col>
                              )}
                        </Row>
                        <Row>
                          <Col xs={3}>
                            <h3>Apply Fee type to:</h3>
                          </Col>
                          <Col xs={2}>
                            <FormGroup check>
                              <Input
                                type="checkbox"
                                id="taxHammer"
                                name="taxHammer"
                                disabled
                                checked={item.feeHammer}
                              />
                              <Label check>
                                Hammer
                              </Label>
                            </FormGroup>
                          </Col>
                          <Col xs={2}>
                            <FormGroup check>
                              <Input
                                type="checkbox"
                                id="taxLiveFee"
                                name="taxLiveFee"
                                disabled
                                checked={item.feeLiveFee}
                              />
                              <Label check>
                                Live Fee
                              </Label>
                            </FormGroup>
                          </Col>
                          <Col xs={2}>
                            <FormGroup check>
                              <Input
                                type="checkbox"
                                id="taxPremium"
                                name="taxPremium"
                                disabled
                                checked={item.feePremium}
                              />
                              <Label check>
                                BP
                              </Label>
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                    </>
                  );
                })}
              </div>
            )}
    <Row className="mt-5">
      <Col xs={12} className="mb-3">
        <Alert color="primary">
          Messages
        </Alert>
      </Col>

    </Row>
    {messageData && messageData.map((item, index) => (
      <div key={index}>
        <Row>
          <Col xs={11} sm={4} className={`${item.header ? 'mt-2' : ''}`}>
            <h3>{item.header}</h3>
          </Col>
        </Row>
        <Row className="mt-1 mb-2">
          <Col xs={12} sm={8}>
            {item.detail}
          </Col>
        </Row>
      </div>
    ))}
  </>

);
export default ReadOnlyTemplate;
